// import { useDispatch } from 'react-redux';
import { Button, Dimmer, Header, Loader } from 'semantic-ui-react';
// import useClients from '../../hooks/useClients';
// import useUIModules from '../../hooks/useModules';
import { setEditClient } from '../../redux/actions/clients';

const ClientModules = ({
  clientId: id,
  dispatch,
  modules: uiModules,
  client,
}: any) => {
  // const { clients } = useClients();
  // const client = clients[id];
  // const { modules, isLoading: modulesLoading } = useUIModules();
  // const dispatch = useDispatch();
  const getModules = () => {
    if (uiModules && client) {
      if (!client.ModuleIds) return <li key={'all'}>All</li>;
      else {
        return uiModules
          .filter((module) => client.ModuleIds.includes(module.Id))
          .map((module) => {
            return <li key={module.Id}>{module.Title}</li>;
          });
      }
    }
    return null;
  };

  return (
    <div>
      <Header>UI Modules</Header>

      {!uiModules ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : (
        <>
          <ul>{getModules()}</ul>
          <Button onClick={() => dispatch(setEditClient(client))}>
            Manage modules
          </Button>
        </>
      )}
    </div>
  );
};

export default ClientModules;
